<template>
  <div class="form__block">
    <div class="content">
      <template v-for="(row, index) in rows">
        <span
          class="content__text"
          v-show="row.display"
          :key="'details' + index"
        >
          <span class="mod mod--size--22 mod--weight--600">{{
            row.title
          }}</span>
          <span class="mod mod--size--17 mod--weight--600">{{
            row.label
          }}</span>
          <br />
          <span
            class="mod mod--size--17 mod--weight--300"
            v-html="row.content"
          ></span>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ["fields", "details"],
  name: "checkout-details",
  computed: {
    rows: function() {
      return this.details.map(
        ({ conditions, content, filters, label, title }) => ({
          display: !conditions
            ? true
            : conditions.reduce((display, condition) => {
                let field = condition.field.reduce(
                  (parent, name) => {
                    if (!parent) return null;

                    let field = parent.fields.find(
                      fields => fields.name === name
                    );

                    if (field) return field;
                    if (parent.type != "conditional") return null;
                    if (!parent.fields) return null;

                    let selectedField = parent.fields.find(
                      field => field.name === parent.value
                    );

                    if (!selectedField) return null;

                    return (
                      selectedField.fields &&
                      selectedField.fields.find(fields => fields.name === name)
                    );
                  },
                  { fields: this.fields }
                );

                if (condition.not === "true") {
                  return field ? field.value != condition.value : false;
                }

                return (
                  display || (field ? field.value == condition.value : false)
                );
              }, false),
          content:
            content &&
            content
              .map((content, index) => {
                var field;
                var text = "";

                if (Array.isArray(content)) {
                  field = content.reduce(
                    (parent, name) => {
                      if (!parent) return null;

                      let field = parent.fields.find(
                        fields => fields.name === name
                      );

                      if (field) return field;
                      if (parent.type != "conditional") return null;
                      if (!parent.fields) return null;

                      let selectedField = parent.fields.find(
                        field => field.name === parent.value
                      );

                      if (!selectedField) return null;

                      return (
                        selectedField.fields &&
                        selectedField.fields.find(
                          fields => fields.name === name
                        )
                      );
                    },
                    { fields: this.fields }
                  );
                }

                text = field ? field.value : content;

                if (field && field.options) {
                  let option = field.options.find(
                    option => option.value === field.value
                  );
                  text = option ? option.label : "";
                }

                return filters && filters[index]
                  ? eval("text." + filters[index])
                  : text;
              })
              .join(""),
          label: label,
          title: title
        })
      );
    }
  }
};
</script>
